var $76b10eb557cd29a5$exports = {};
$76b10eb557cd29a5$exports = {
    "valid": `\u{635}\u{627}\u{644}\u{62D}`
};


export {$76b10eb557cd29a5$exports as default};
//# sourceMappingURL=ar-AE.mjs.map
